export const defaultValues = {
	nip: '',
	bankAccountNumber: '',
	email: '',
	phoneNumber: '',
};

